/**
 * OfflineBanner — pinned strip shown at the top of the app when we detect
 * no internet connection. Reads useNetwork().isOffline; no-op when online.
 */
import React from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import { useNetwork } from '../context/NetworkContext';
import { useTheme } from '../context/ThemeContext';

export function OfflineBanner() {
  const { isOffline } = useNetwork();
  const { colors } = useTheme();

  if (!isOffline) return null;

  return (
    <View style={[styles.bar, { backgroundColor: colors.warning }]} pointerEvents="none">
      <Ionicons name="cloud-offline-outline" size={16} color="#1a1a1a" />
      <Text style={styles.text}>No internet connection — changes will retry when you're back online.</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  bar: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    paddingHorizontal: 12,
    paddingVertical: 8,
    ...(Platform.OS === 'web' ? { position: 'sticky' as any, top: 0, zIndex: 1000 } : {}),
  },
  text: {
    color: '#1a1a1a',
    fontSize: 13,
    fontWeight: '600',
    flexShrink: 1,
    textAlign: 'center',
  },
});
